import { render, staticRenderFns } from "./ShopCardList.vue?vue&type=template&id=56db99a4&scoped=true&"
import script from "./ShopCardList.vue?vue&type=script&lang=js&"
export * from "./ShopCardList.vue?vue&type=script&lang=js&"
import style0 from "./ShopCardList.vue?vue&type=style&index=0&id=56db99a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db99a4",
  null
  
)

export default component.exports